import { LigneMouvement, Rib } from '@mairistem/comptabilite';

const getLibelleBanque = (rib: Rib): string | undefined => {
  if (rib?.estBanqueEtrangere) {
    return rib?.banqueEtrangere?.nom;
  }
  if (rib?.guichet?.banque?.nom && rib?.guichet?.nom) {
    return `${rib.guichet.banque.nom} ${rib.guichet.nom}`;
  }
  return undefined;
};

const getRibChanges = (rib: Rib): Partial<LigneMouvement> => {
  const libelleBanque = getLibelleBanque(rib);

  return {
    cleRib: rib?.cleRib,
    codeBanque: rib?.guichet?.banque?.code,
    codeBic: rib?.bic,
    codeGuichet: rib?.guichet?.code,
    iban: rib?.iban,
    ...(rib?.estBanqueEtrangere && { identificationInternationaleBanque: rib?.banqueEtrangere?.bic }),
    libelleBanque,
    numeroCompte: rib?.compte,
    titulaireCompte: rib?.titulaire,
  };
};

export default getRibChanges;
